import React, { useCallback, useState } from "react";
import { Divider, Modal, Space } from "antd";
import CustomButton from "components/Common/buttons/CustomButton";
import { makeStyles } from "@material-ui/core/styles";
import CalendarPicker from "pages/customer-management/customerDetails/CalendarPicker";

const useStyles = makeStyles({
  modalWrapper: {
    width: "400px!important",

    "&> .ant-modal-content .ant-modal-body": {
      padding: "24px !important",
    },
    "&> .ant-modal-content .ant-modal-header": {
      padding: "24px 24px 0 !important",
    },
  },
  descriptionTitle: {
    display: "flex",
    flexDirection: "column",
    textAlign: "left",
    fontWeight: 600,

    "&>span": {
      fontSize: 13,
      fontWeight: 300,
    },
  },
  withIcon: {
    display: "flex",
    alignItems: "center",

    "&>img": {
      marginRight: 10,
    },
  },
  notReachableBtn: {
    border: "2px solid #FF2E00",
    color: "#FF2E00",
  },
  calendarContainer: {
    borderTop: "1px solid rgb(240 240 240)",
    paddingTop: 20,
  },
});
const SetAcquisitionDateModal = ({ onClose, date, onSave }) => {
  const classes = useStyles();
  const [selectedDate, setSelectedDate] = useState(date || null);

  const onSubmit = useCallback(() => onSave(selectedDate), [selectedDate]);

  return (
    <Modal
      title={
        <div className={classes.withIcon}>
          <div className={classes.descriptionTitle}>Acquisition Date</div>
        </div>
      }
      open
      onCancel={onClose}
      footer={[]}
      className={classes.modalWrapper}
      closable={false}
    >
      <div className={classes.calendarContainer}>
        <CalendarPicker limit={90} selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
        <Divider />
        <Space>
          <CustomButton onClick={onClose} type="primary" color="outlined" text="CANCEL" size="small" />
          <CustomButton
            onClick={onSubmit}
            disabled={!selectedDate?.availableAt || !selectedDate?.timeSlot}
            type="primary"
            text="Confirm"
            size="small"
          />
        </Space>
      </div>
    </Modal>
  );
};

export default SetAcquisitionDateModal;
